import { render, staticRenderFns } from "./ActivityAgendaView.vue?vue&type=template&id=0636a74a&scoped=true&"
import script from "./ActivityAgendaView.vue?vue&type=script&lang=js&"
export * from "./ActivityAgendaView.vue?vue&type=script&lang=js&"
import style0 from "./ActivityAgendaView.vue?vue&type=style&index=0&id=0636a74a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0636a74a",
  null
  
)

export default component.exports